<div class="modal-header pt-1 pb-1">
  <h4 class="modal-title" id="modal-basic-title"></h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"> </button>
</div>
<div class="modal-body">
  <form [formGroup]="addUserForm" (ngSubmit)="onSubmit()">
    <h5 class="text-center">{{ 'Add New User' | translate }}</h5>
    <div class="row mt-4">
      <div class="col">
        <label
          [style.position]="'relative'"
          [style.z-index]="'2'"
          [style.width]="'100%'"
          [ngClass]="{ 'has-danger': isValid('username') }">
          <mtm-inviter-dropdown
            class="flex-fill me-1"
            [data]="companyUsers"
            [(value)]="invitedUsers"
            [internalUsersOnly]="true"
            (selectedInvitersChange)="selectedInvitersChange($event)"
            [iconSize]="24"
            [userInfo]="'nameOnly'"
            [inputPlaceholder]="'nameOrEmail' | translate"
            [singleInput]="true"
            [asClassicDropdown]="true">
          </mtm-inviter-dropdown>
          <input
            [hidden]="true"
            class="form-control"
            type="text"
            formControlName="username"
            placeholder=" "
            [ngClass]="{ 'form-control-danger': isValid('username') }" />
          <span *ngIf="isValid('username')" [ngClass]="{ 'text-danger': isValid('username') }"
            >Email address{{ isValid('username') ? ' is required' : '' }}</span
          >
        </label>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <button class="btn btn-outline-secondary btn-lg w-100" type="button" (click)="closeModal()">
          <span>{{ 'Cancel' | translate }}</span>
        </button>
      </div>
      <div class="col">
        <button class="btn btn-danger btn-lg w-100" type="submit" [disabled]="!addUserForm.valid">
          <span>{{ 'Invite' | translate }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
